(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbtfy-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mww-carousel')) {
    class MWWCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-mww-track]');
        if (!this.track) return;

        this.prevBtn = this.querySelector('[data-mww-prev]');
        this.nextBtn = this.querySelector('[data-mww-next]');
        this.delay = Math.max(1500, parseInt(this.dataset.interval, 10) || 4000);
        this.glideSpeed = Math.max(5, parseFloat(this.dataset.glide) || 40);
        this.motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.glide = this.dataset.mode === 'glide' && this.motionOK;
        this.loop = this.dataset.loop === 'true';
        this.wantsAuto = this.dataset.autoplay === 'true' && this.motionOK;
        this.onScreen = true;
        this.held = false;

        this._tick = this._tick.bind(this);
        this._frame = this._frame.bind(this);
        this._onVisibility = this._onVisibility.bind(this);
        this._onScroll = this._onScroll.bind(this);
        this._sync = this._sync.bind(this);
        this._hold = this._hold.bind(this);
        this._release = this._release.bind(this);

        if (this.loop) this._buildLoop();

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.nudge(-1, true));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nudge(1, true));

        this.addEventListener('mouseenter', this._hold);
        this.addEventListener('mouseleave', this._release);
        this.addEventListener('focusin', this._hold);
        this.addEventListener('focusout', this._release);
        this.track.addEventListener('pointerdown', this._hold, { passive: true });
        this.track.addEventListener('touchstart', this._hold, { passive: true });
        this.track.addEventListener('scroll', this._onScroll, { passive: true });
        document.addEventListener('visibilitychange', this._onVisibility);

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this._sync);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this._sync);
        }

        // only spend cycles while the section is actually on screen
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              this.onScreen = entries[0].isIntersecting;
              this.onScreen ? this.start() : this.stop();
            },
            { threshold: 0.15 }
          );
          this.io.observe(this);
        }

        this.setAttribute('data-mww-ready', '');
        this._sync();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this._onVisibility);
        window.removeEventListener('resize', this._sync);
        clearTimeout(this._idle);
        clearTimeout(this._resume);
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      /* ---- seamless loop -------------------------------------------------
         A second copy of every card is appended. Once the track has scrolled
         one full set, scrollLeft is rolled back by exactly that distance --
         the pixels either side of the seam are identical, so the reset is
         invisible and the row never has to rewind. */
      _buildLoop() {
        this.originals = Array.from(this.track.children);
        if (this.originals.length < 2) {
          this.loop = false;
          return;
        }
        const frag = document.createDocumentFragment();
        this.originals.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('data-mww-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, [tabindex]').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          });
          frag.appendChild(clone);
        });
        this.track.appendChild(frag);
      }

      get stride() {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      get cycle() {
        return this.loop && this.originals ? this.stride * this.originals.length : 0;
      }

      overflows() {
        return this.track.scrollWidth - this.track.clientWidth > 4;
      }

      _wrap(x) {
        const c = this.cycle;
        if (c <= 0) return x;
        if (x >= c) return x - c;
        if (x < 0) return x + c;
        return x;
      }

      nudge(dir, manual) {
        const t = this.track;

        if (this.loop && this.cycle > 0) {
          // land inside the first set *before* animating, so the smooth
          // scroll itself is never interrupted by the reset
          const wrapped = this._wrap(t.scrollLeft);
          if (dir < 0 && wrapped < this.stride) t.scrollLeft = wrapped + this.cycle;
          else t.scrollLeft = wrapped;
        }

        const max = t.scrollWidth - t.clientWidth;
        let target = t.scrollLeft + dir * this.stride;

        if (!this.loop) {
          if (dir > 0 && t.scrollLeft >= max - 2) target = 0;
          else if (dir < 0 && t.scrollLeft <= 2) target = max;
        }

        t.scrollTo({ left: target, behavior: this.motionOK ? 'smooth' : 'auto' });
        if (manual) this.restart();
      }

      _tick() {
        this.nudge(1);
      }

      /* ---- continuous glide ---- */
      _frame(ts) {
        if (this._last == null) this._last = ts;
        const dt = Math.min(64, ts - this._last);
        this._last = ts;
        this.pos = this._wrap(this.pos + (this.glideSpeed * dt) / 1000);
        this.track.scrollLeft = this.pos;
        this.raf = requestAnimationFrame(this._frame);
      }

      start() {
        if (!this.wantsAuto || this.held || !this.onScreen) return;
        if (document.hidden || !this.overflows()) return;

        if (this.glide && this.loop) {
          if (this.raf) return;
          this.pos = this.track.scrollLeft;
          this._last = null;
          this.raf = requestAnimationFrame(this._frame);
          return;
        }
        if (this.timer) return;
        this.timer = setInterval(this._tick, this.delay);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        this._last = null;
      }

      restart() {
        this.stop();
        // let a manual smooth scroll finish before autoplay takes over again
        clearTimeout(this._resume);
        this._resume = setTimeout(() => this.start(), 700);
      }

      _hold() {
        this.held = true;
        this.stop();
      }

      _release() {
        this.held = false;
        this.start();
      }

      _onVisibility() {
        document.hidden ? this.stop() : this.start();
      }

      // after a free scroll (touch / trackpad) settles, fold the position
      // back into the first set so the loop keeps working
      _onScroll() {
        if (!this.loop || this.raf) return;
        clearTimeout(this._idle);
        this._idle = setTimeout(() => {
          if (this.cycle > 0) this.track.scrollLeft = this._wrap(this.track.scrollLeft);
        }, 160);
      }

      _sync() {
        this.toggleAttribute('data-mww-fits', !this.overflows());
        this.overflows() ? this.start() : this.stop();
      }
    }

    customElements.define('mww-carousel', MWWCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(Debutify.settings.dbtfy_sticky_header == false) return;

      this.defaultColorScheme = "dbtfy-color-"+this.dataset.colorScheme;
      this.defaultCustomColorScheme = "color-"+this.dataset.customColorScheme;
      this.transparentColorScheme = "dbtfy-color-"+this.dataset.transparentHeaderColorScheme;
      this.transparentCustomColorScheme = "color-"+this.dataset.customTransparentHeaderColorScheme;
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
        this.classList.add('dbtfy-header--transparent');
        this.classList.add(this.transparentColorScheme);
        this.classList.add(this.transparentCustomColorScheme);
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        
        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.defaultColorScheme,this.defaultCustomColorScheme);
          if(this.classList.contains("dbtfy-header--transparent")){
            this.classList.remove('dbtfy-header--transparent');
          }
          if(this.transparentColorScheme){
            this.classList.remove(this.transparentColorScheme);
          }
          if (this.transparentCustomColorScheme) {
            this.classList.remove(this.transparentCustomColorScheme);
          }
        }
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {

        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.transparentColorScheme,this.transparentCustomColorScheme,'dbtfy-header--transparent');
          if(this.defaultColorScheme){
            this.classList.remove(this.defaultColorScheme);
          }
          if (this.defaultCustomColorScheme) {
            this.classList.remove(this.defaultCustomColorScheme);
          }
        }

        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
